function removeDimensionShadows(l, h, w){
    let sceneDimensions = {
        length :l,
        width :h,
        height :w,
    }

    Object.keys(sceneDimensions).forEach(function(key) {
        sceneDimensions[key].traverse(n => {
            if (n.isMesh) {
                n.castShadow = false
                n.receiveShadow = false
            }
        })
    }); 
}
function setUnitsShadowsTrue(fullunit){
    fullunit.traverse(n => {
        if (n.isMesh) {
            n.castShadow = true
            n.receiveShadow = true
        }
    })
}

export {
    removeDimensionShadows,
    setUnitsShadowsTrue,
}